<template>
  <a-modal
    :visible="visible"
    title="选择剔除个体"
    @cancel="on_close"
    :width="1000"
    @ok="on_confirm"
    okText="确认选择"
    cancelText="取消"
  >
    <a-page-header>
      <a-input
        v-model="query.vid"
        placeholder="请输入编号"
        @blur="refresh_list"
        allowClear
        style="width: 200px"
      ></a-input>
    </a-page-header>
    <a-table
      :data-source="list"
      :columns="columns"
      :pagination="pagination"
      @change="handleTableChange"
      :row-selection="rowSelection"
      :row-key="record => record.id"
    >
      <template slot="vid" slot-scope="vid, row">
        {{ vid || "-" }}
      </template>
      <template slot="export_tag" slot-scope="export_tag, row">
        {{ export_tag || "-" }}
      </template>
      <template slot="rf_id" slot-scope="rf_id, farm_id">
        {{ rf_id || "-" }}
      </template>
      <template slot="father" slot-scope="father">
        {{ father || "-" }}
      </template>
      <template slot="mother" slot-scope="mother">
        {{ mother || "-" }}
      </template>
      <template slot="birth_date" slot-scope="birth_date">
        {{ birth_date || "-" }}
      </template>
      <template slot="gender" slot-scope="gender">
        {{ gender == 0 ? "母" : "公" }}
      </template>
    </a-table>
    <div style="margin-top: 16px">
      <span>已选择 {{ selectedRowKeys.length }} 个个体</span>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: "ItemMultiSelect",
  data() {
    return {
      visible: false,
      farm_id: null,
      query: {
        vid: "",
        page_no: 1,
        page_size: 20,
        farm_id: undefined,
      },
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      pagination: {
        pageSize: 20,
        current: 1,
        total: 0,
        showTotal: (total) => `共 ${total} 条记录`,
      },
      columns: [
        {
          title: "Id",
          dataIndex: "id",
          key: "id",
        },
        {
          title: "Vid",
          dataIndex: "vid",
          key: "vid",
          scopedSlots: { customRender: "vid" },
        },
        {
          title: "出口号",
          dataIndex: "export_tag",
          key: "export_tag",
          scopedSlots: { customRender: "export_tag" },
        },
        {
          title: "RF-Id",
          dataIndex: "rf_id",
          key: "rf_id",
          scopedSlots: { customRender: "rf_id" },
        },
        {
          title: "父亲",
          dataIndex: "item_father",
          key: "father",
          scopedSlots: { customRender: "father" },
        },
        {
          title: "母亲",
          dataIndex: "item_mother",
          key: "mother",
          scopedSlots: { customRender: "mother" },
        },
        {
          title: "出生日期",
          dataIndex: "birth_date",
          key: "birth_date",
          scopedSlots: { customRender: "birth_date" },
        },
        {
          title: "性别",
          dataIndex: "gender",
          key: "gender",
          scopedSlots: { customRender: "gender" },
        },
      ],
    };
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys;
          this.selectedRows = selectedRows;
        },
        getCheckboxProps: (record) => ({
          name: record.vid,
        }),
      };
    },
  },
  methods: {
    open(options) {
      this.list = [];
      this.selectedRowKeys = [];
      this.selectedRows = [];
      this.visible = true;
      this.farm_id = options.farm_id;
      this.query.farm_id = options.farm_id;
      this.refresh_list();
    },
    handleTableChange(pagination, filters, sorter) {
      this.query.page_no = pagination.current;
      this.pagination = pagination;
      this.refresh_list();
    },
    refresh_list() {
      this.list = [];
      this.$api.get_breed_items(this.query).then((res) => {
        this.list = res.data.list;
        this.pagination.total = res.data.page.total;
        this.pagination.total_pages = res.data.page.total_pages;
      });
    },
    on_confirm() {
      this.$emit("select-over", this.selectedRows);
      this.visible = false;
    },
    on_close() {
      this.visible = false;
      this.list = [];
      this.selectedRowKeys = [];
      this.selectedRows = [];
      this.query.vid = "";
    },
  },
};
</script>

<style></style>
